const LEGACY_VERIFY_MOCK_STORAGE_KEYS = [
  'verify_center_records',
  'verify_center_seed_version',
  'verify_clue_records',
  'verify_clue_seed_version',
  'verify_clue_group_records'
]

export const cleanupLegacyVerifyMockData = () => {
  if (typeof window === 'undefined') return

  LEGACY_VERIFY_MOCK_STORAGE_KEYS.forEach((key) => {
    window.localStorage.removeItem(key)
  })
}
